import { TimelineFilingRow } from "store/apis/filingsTimeline";
import { type TimelineStatus } from "constants/filingsTimeline";

export const getTimelineStatus = (filing: TimelineFilingRow): TimelineStatus =>
  filing.status_bucket;
